import type { ConversationInvitationQuestionResource } from "api/generated";
import type { ConversationQuestion } from "conversations/types";

/**
 * `options` is null for every type except radio. Normalised to `[]` so a template can
 * iterate it without a null check.
 */
export const conversationQuestionFromDto = (
  dto: ConversationInvitationQuestionResource,
): ConversationQuestion => ({
  id: dto.id,
  question: dto.question,
  type: dto.type,
  options: dto.options ?? [],
  required: dto.required,
  order: dto.order,
});

export const conversationQuestionsFromDto = (
  dtos: ConversationInvitationQuestionResource[],
): ConversationQuestion[] => dtos.map(conversationQuestionFromDto);
